__turbopack_context__.v({
  "active": "MenuTopics-module-scss-module__BQyaZa__active",
  "link": "MenuTopics-module-scss-module__BQyaZa__link",
  "menu": "MenuTopics-module-scss-module__BQyaZa__menu",
});
